import React from 'react'
import style from './index.module.css'
export default function Contact() {
  return (
    <div>
        <div className={style.contact}>
            <div className={style.our}>
                <p><a href=''>Home</a>/<span>Contact</span></p>
                <h1>Contact With Us</h1>
            </div>
            <div className={style.img}>
                <img src='https://new.axilthemes.com/demo/template/etrade/assets/images/product/product-45.png'></img>
            </div>
        </div>
        <div className={style.we}>
          <div className={style.contact1}>
            <h1>We would love to hear from you.</h1>
            <p>If you’ve got great products your making or looking to work with us then drop us a line.</p>
            <div className={style.input}>
              <div className={style.form}>
                  <label>Name <span>*</span></label>
                  <input type='text'></input>
              </div>
              <div className={style.form}>
                  <label>Phone <span>*</span></label>
                  <input type='text'></input>
              </div>
              <div className={style.form}>
                  <label>E-mail <span>*</span></label>
                  <input type='text'></input>
              </div>
              <div className={style.form}>
                  <label>Your Message</label>
                  <textarea cols='1' rows='2'></textarea>
              </div>
            </div>
            <a href=''>Send Message</a>
          </div>
          <div className={style.stor}>
            <h1>Our Store</h1>
            <p>8212 E. Glen Creek Street Orchard Park, NY 14127, United States of America</p>
            <p>Phone: +123 456 7890<br></br>
            Email: Hello@etrade.com</p>
            <h1>Careers</h1>
            <p>Instead of buying six things, one that you really like.</p>
            <h1>Opening Hours</h1>
            <p>Monday to Saturday: 9am - 10pm
            Sundays: 10am - 6pm</p>
          </div>
        </div>
        <div className={style.map}>
          <iframe height='400' width='1060' src='https://maps.google.com/maps?q=melbourne&t=&z=13&ie=UTF8&iwloc=&output=embed'></iframe>
        </div>
    </div>
  )
}
 